<template>
    <div>
        <div class="container">
            <div class="main__top">
                <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">talent search</h1>
                <div class="filter mb-0 wow fadeInUp" data-wow-duration="1.5s">
                    <form action="">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="filter__item">
                                    <input type="text" class="filter__text" placeholder="Act Name">
                                </div>
                            </div>
                            <div class="col-6 col-md-4">
                                <div class="filter__item">
                                    <select class="custom-select">
                                        <option value="">Select Category</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-6 col-md-4">
                                <div class="filter__item">
                                    <select class="custom-select">
                                        <option value="">Select Region</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="filter__item">
                                    <select class="custom-select">
                                        <option value="">Select Venue</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="filter__item">
                                    <input type="date" class="filter__text" placeholder="From">
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="filter__item">
                                    <input type="date" class="filter__text" placeholder="To">
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="filter__item">
                                    <button type="submit" name="" class="btn btn_golden w-100"><span>SEARCH</span></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="talent__view wow zoomIn" data-wow-duration="1.5s">
                <button type="button" area-label="Grid View" class="talent-view-grid active">
                    <svg width="16" height="16" aria-hidden="true">
                        <use href="/img/svg/grid.svg#grid"></use>
                    </svg>
                </button>
                <button type="button" area-label="List View" class="talent-view-list">
                    <svg width="16" height="16" aria-hidden="true">
                        <use href="/img/svg/symbol-defs.svg#icon-list"></use>
                    </svg>
                </button>
            </div>
            <ul class="talent talent_grid talent_grid_lg">
                <li class="talent__item wow zoomIn" data-wow-duration="1.5s">
                    <div class="talent__inner">
                        <a href="./client-artist.php" class="talent__link">
                            <img src="/img/demo/featured-1.jpg" alt="Artist Photo" class="talent__photo">
                        </a>
                        <div class="talent__holder">
                            <h2 class="talent__name">David <strong>Brooks</strong></h2>
                            <p class="talent__category m-0">Piano Headliners</p>
                            <p class="talent__country m-0">USA</p>
                        </div>
                    </div>
                    <a href="./client-artist.php" class="btn btn_golden view-profile"><span>profile</span></a>
                </li>
            </ul>
            <div class="text-center pt-5 wow zoomIn" data-wow-duration="2.0s">
                <a href="./talent-roster.php" class="btn btn_primary-outline">Learn More</a>
            </div>
        </div>
    </div>

</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "TalentSearch",
    data() {
        return {
            search: {
                name: null,
                category: null,
                region: null,
                company: null,
            }
        }
    }

})
</script>
<style scoped>

</style>
